
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import ImageCarousel from '@/components/ImageCarousel.vue';
import ContactCard from '@/components/ContactCard.vue';

@Component({
  components: { Header, ImageCarousel, ContactCard },
})
export default class Home extends Vue {}
